var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgEnvelope28 = ({
  title,
  titleId,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 28,
  height: 28,
  viewBox: "0 0 28 28",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  x: 3,
  y: 6,
  width: 22,
  height: 16,
  rx: 2,
  ry: 2,
  fill: "none",
  stroke: "currentColor",
  strokeWidth: 1
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M3 8L14 14L25 8",
  fill: "none",
  stroke: "currentColor",
  strokeWidth: 1
})));
export default SvgEnvelope28;